module.exports = {"350203001":"厦港街道","350203003":"中华街道","350203005":"滨海街道","350203006":"鹭江街道","350203007":"开元街道","350203008":"梧村街道","350203009":"筼筜街道","350203010":"莲前街道","350203011":"嘉莲街道","350203012":"鼓浪屿街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350203.json
// module id = 1078
// module chunks = 0